import React, { useState, useEffect } from 'react';
import LoginForm from './Components/Login/LoginForm';
import AdminPanel from './Components/AdminPanel/AdminPanel';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard1 from './Components/AdminPanel/Dashboard1';
import EnterUsers from './Components/User/EnterUsers';
import Register from './Components/Login/Register';
import Forget from './Components/Login/Forget';
import AddDepartments from './Components/User/AddDepartments';
import EditDepartments from './Components/User/EditDepartments';
import DepartmentList from './Components/User/DepartmentList';
import AddDesignations from './Components/User/AddDesignations';
import CreateCompany from './Components/SuperAdmin/CreateComapny';
import EditDesignations from './Components/User/EditDesignations';
import Appointments from './Components/Appointments/Appointments';
import AppointmentList from './Components/Appointments/AppointmentList';
import EditAppointment from './Components/Appointments/EditAppointment';
import AppointmentSuccess from './Components/Appointments/AppointmentSuccess';
import BookAppointment from './Components/Appointments/BookAppointment';
import UpdateCompany from './Components/User/UpdateCompany';
import DoctorDashboard from './Components/Doctors/DoctorDashboard'
import AddDoctors from './Components/Doctors/AddDoctors';
import ViewDoctors from './Components/Doctors/ViewDoctors';
import UpdateDoctors from './Components/Doctors/UpdateDoctors';
import DoctorProfile from './Components/Doctors/DoctorProfile';
import DocAppointment from './Components/Appointments/DocAppointment';
import MyPatients from './Components/Patients/MyPatients';
import PatientsProfile from './Components/Patients/PatientsProfile';
import EditPatients from './Components/Patients/EditPatients';
import PatientsLists from './Components/Patients/PatientsLists';
import AddPatients from './Components/Patients/AddPatients';
import RoomStatistics from './Components/Rooms/RoomStatistics';
import RoomsAlloted from './Components/Rooms/RoomsAlloted';
import RoomsByDepartment from './Components/Rooms/RoomsByDepartment';
import AvailableRooms from './Components/Rooms/AvailableRooms';
import BookRooms from './Components/Rooms/BookRooms';
import AddRooms from './Components/Rooms/AddRooms';
import AllRooms from './Components/Rooms/AllRooms';
import ViewUser from './Components/User/ViewUser';
import EditUser from './Components/User/EditUser';
import EditLabTechnicians from './Components/LabTechnicians/editLabTechnicians';
import EditNurse from './Components/Nurse/Nurse';
import EditPharmacists from './Components/Pharmacists/Pharmacists';
import EditReceptionists from './Components/Receptionsists/Receptionists';

import CompanySetting from './Components/SuperAdmin/CompanySettings';
import ViewCompany from './Components/SuperAdmin/ViewCompany';
import SadminDashboard from './Components/SuperAdmin/Dashboard';
import Departments from './Components/User/Departments';
import CreateModules from './Components/Modules/CreateModules';
import CreateModulesMenu from './Components/Modules/CreateModulesMenu';
import CreateSubMenu from './Components/Modules/CreateSubMenu';
import UserType from './Components/User/UserType';
import CreateNoti from './Components/SuperAdmin/CreateNoti';
import CreateCompanyType from './Components/SuperAdmin/CreateCompanyType';
import CreateRoles from './Components/SuperAdmin/CreateRoles';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Use state to track login status

  useEffect(() => {
    // Check if we have a stored value in sessionStorage
    const storedUsername = sessionStorage.getItem('email');
    if (storedUsername) {
      setIsLoggedIn(true); // Update state if there's an email in sessionStorage
    }
  }, []); // Empty dependency array ensures this runs only once after the first render
  if (isLoggedIn) {
    return (
      <Router>
        <Routes>
        
          <Route path="/" element={<AdminPanel />}>

            <Route path="/dashboard" element={<Dashboard1 />} />
            <Route path="/dashboard-company" element={<Dashboard1 />} />
            <Route path="/add-users" element={<EnterUsers />} />
            <Route path="/" element={<Dashboard1 />} />
            <Route path="/add-departments" element={<AddDepartments />} />
            <Route path="/edit-departments" element={<EditDepartments />} />
            <Route path="/departments-list" element={<DepartmentList />} />
            <Route path="/add-designations" element={<AddDesignations />} />
            <Route path="/edit-designations" element={<EditDesignations />} />
            <Route path="/create-company" element={<CreateCompany />} />
            <Route path="/appointment-list" element={<AppointmentList />} />
            <Route path="/appointments" element={<Appointments />} />
            <Route path="/appointment-success" element={<AppointmentSuccess />} />
            <Route path="/book-appointment" element={<BookAppointment />} />
            <Route path="/edit-appointment" element={<EditAppointment />} />
            <Route path="/view-company" element={<ViewCompany />} />
            <Route path="/update-company" element={<UpdateCompany />} />
            <Route path="/doctor-dashboard" element={<DoctorDashboard />} />
            <Route path="/add-doctors" element={<AddDoctors />} />
            <Route path="/view-doctors" element={<ViewDoctors />} />
            <Route path="/update-doctors" element={<UpdateDoctors />} />
            <Route path="/doctor-profile" element={<DoctorProfile />} />
            <Route path="/doc-appointment" element={<DocAppointment />} />
            <Route path="/my-patients" element={<MyPatients />} />
            <Route path="/patients-profile" element={<PatientsProfile />} />
            <Route path="/edit-patients" element={<EditPatients />} />
            <Route path="/add-patients" element={<AddPatients />} />
            <Route path="/patients-lists" element={<PatientsLists />} />
            <Route path="/statistics" element={<RoomStatistics />} />
            <Route path="/rooms-allotted" element={<RoomsAlloted />} />
            <Route path="/rooms-by-department" element={<RoomsByDepartment />} />
            <Route path="/available-rooms" element={<AvailableRooms />} />
            <Route path="/all-rooms" element={<AllRooms />} />
            <Route path="/book-rooms" element={<BookRooms />} />
            <Route path="/add-rooms" element={<AddRooms />} />
            <Route path="/view-users" element={<ViewUser />} />
            <Route path="/admin-update" element={<EditUser />} />
            <Route path="/edit-lab-technicians" element={<EditLabTechnicians />} />
            <Route path="/update-nurse" element={<EditNurse />} />
            <Route path="/edit-pharmacists" element={<EditPharmacists />} />
            <Route path="/edit-receptionist" element={<EditReceptionists />} />
            <Route path="/company-settings" element={<CompanySetting />} />
            <Route path="/dashboard-sadmin" element={<SadminDashboard />} />
            <Route path="/add-departments" element={<Departments/>}/>
            <Route path="/create-modules" element={<CreateModules/>}/>
            <Route path="/create-modules-menu" element={<CreateModulesMenu/>}/>
            <Route path="/create-sub-menu" element={<CreateSubMenu/>}/>
            <Route path="/user-type" element={<UserType/>}/>
            <Route path="/notifications" element={<CreateNoti/>}/>
            <Route path="/company-type" element={<CreateCompanyType/>}/>
            <Route path="/create-roles" element={<CreateRoles/>}/>
          </Route>
        </Routes>
      </Router>
    );
  } else {
    return (
      <Router><Routes><Route path="/" element={<LoginForm />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forget" element={<Forget />} /></Routes></Router>);

  }
}

export default App;
